import { SalesforceCloud } from './salesforce.constants'

export const statusPageUrls: Partial<Record<SalesforceCloud, string>> = {
  Beta: `${process.env.PORTAL_API_BASE_URL}/statuspage/Beta`,
  Gamma: `${process.env.PORTAL_API_BASE_URL}/statuspage/Gamma`,
  Kappa: `${process.env.PORTAL_API_BASE_URL}/statuspage/Kappa`,
  Iota: `${process.env.PORTAL_API_BASE_URL}/statuspage/Iota`,
  Phi: `${process.env.PORTAL_API_BASE_URL}/statuspage/Phi`,
}
